"use strict";

module.exports = {
  "CDNConfig": {
    "firebaseConfig": {
      "messagingSenderId": "684478356926",
      "apiKey": "AIzaSyBR3ABzdk8HG2-_4TS7C5XdYVfXzNSjYhM",
      "projectId": "cdn-prd",
      "appId": "1:684478356926:web:7f83eefecae08da6fbadef",
      "publicVapidKey": "BDL83gCmZ8ZD-YfUd2n8-5fHJ9pOozg8mu01xQpeSWdYWQiO8gyTvDqvAkQAPrqRc4W3fNC_bsCv9rZ3nEwolwA"
    },
    "proxyPath": "/api/central-de-notificacao",
    "apiHost": "https://comprarveiculos.webmotors.com.br/api/central-de-notificacao",
    "devApiHost": "https://comprarveiculos.webmotors.com.br/api/central-de-notificacao",
    "currentEnv": "production",
    "productsConfig": {
      "autoguru": [{
        "host": "autoguru-dev.webmotors.com.br",
        "regexp": "/autoguru-dev.(webmotors|cockpit).com.br/",
        "identifier": "autoguru",
        "environment": "development"
      }, {
        "host": "hkautoguru.webmotors.com.br",
        "regexp": "/cockpit.com.br\\/autoguru/",
        "identifier": "autoguru",
        "environment": "staging"
      }, {
        "host": "autoguru.webmotors.com.br",
        "regexp": "/((www\\.)|[^(\\.)])cockpit.com.br\\/autoguru/",
        "identifier": "autoguru",
        "environment": "production"
      }, {
        "host": "azulautoguru.webmotors.com.br",
        "regexp": "/azl.cockpit.com.br\\/autoguru/",
        "identifier": "autoguru",
        "environment": "blue"
      }],
      "cockpit": [{
        "regexp": "/(local|cockpit-dev).(webmotors|cockpit).com.br/",
        "host": "cockpit-dev.webmotors.com.br",
        "identifier": "cockpit",
        "environment": "development"
      }, {
        "host": "cockpit.com.br",
        "identifier": "cockpit",
        "environment": "staging"
      }, {
        "host": "www.cockpit.com.br",
        "identifier": "cockpit",
        "environment": "production"
      }, {
        "host": "azl.cockpit.com.br",
        "identifier": "cockpit",
        "environment": "blue"
      }],
      "comprar_veiculos": [{
        "host": "comprar-veiculos-dev.webmotors.com.br",
        "regexp": "/comprar-veiculos-dev.(webmotors|cockpit).com.br/",
        "identifier": "comprar_veiculos",
        "environment": "development"
      }, {
        "host": "hkcomprarveiculos.webmotors.com.br",
        "regexp": "/cockpit.com.br\\/(resale|buy-vehicles)/",
        "identifier": "comprar_veiculos",
        "environment": "staging"
      }, {
        "host": "comprarveiculos.webmotors.com.br",
        "regexp": "/((www\\.)|[^(\\.)])cockpit.com.br\\/(resale|buy-vehicles)/",
        "identifier": "comprar_veiculos",
        "environment": "production"
      }, {
        "host": "azulcomprarveiculos.webmotors.com.br",
        "regexp": "/azl.cockpit.com.br\\/(resale|buy-vehicles)/",
        "identifier": "comprar_veiculos",
        "environment": "blue"
      }],
      "crm": [{
        "host": "crm-dev.cockpit.com.br",
        "regexp": "/crm-dev.(webmotors|cockpit).com.br/",
        "identifier": "crm",
        "environment": "development"
      }, {
        "host": "hkcrm.webmotors.com.br",
        "regexp": "/cockpit.com.br\\/crm/",
        "identifier": "crm",
        "environment": "staging"
      }, {
        "host": "crm.webmotors.com.br",
        "regexp": "/((www\\.)|[^(\\.)])cockpit.com.br\\/crm/",
        "identifier": "crm",
        "environment": "production"
      }, {
        "host": "azulcrm.webmotors.com.br",
        "regexp": "/azl.cockpit.com.br\\/crm/",
        "identifier": "crm",
        "environment": "blue"
      }],
      "estoque": [{
        "host": "estoque-dev.cockpit.com.br",
        "regexp": "/estoque-dev.(webmotors|cockpit).com.br/",
        "identifier": "estoque",
        "environment": "development"
      }, {
        "host": "hestoque.webmotors.com.br",
        "regexp": "/cockpit.com.br\\/(inventory|estoque)/",
        "identifier": "estoque",
        "environment": "staging"
      }, {
        "host": "estoque.webmotors.com.br",
        "regexp": "/((www\\.)|[^(\\.)])cockpit.com.br\\/(inventory|estoque)/",
        "identifier": "estoque",
        "environment": "production"
      }, {
        "host": "azulestoque.webmotors.com.br",
        "regexp": "/azl.cockpit.com.br\\/(inventory|estoque)/",
        "identifier": "estoque",
        "environment": "blue"
      }],
      "gearbox": [{
        "host": "gb-dev.webmotors.com.br",
        "regexp": "/gb-dev.(webmotors|cockpit).com.br/",
        "identifier": "gearbox",
        "environment": "development"
      }, {
        "host": "hgb.webmotors.com.br",
        "regexp": "/cockpit.com.br\\/gearbox/",
        "identifier": "gearbox",
        "environment": "staging"
      }, {
        "host": "gb.webmotors.com.br",
        "regexp": "/((www\\.)|[^(\\.)])cockpit.com.br\\/gearbox/",
        "identifier": "gearbox",
        "environment": "production"
      }, {
        "host": "azulgb.webmotors.com.br",
        "regexp": "/azl.cockpit.com.br\\/gearbox/",
        "identifier": "gearbox",
        "environment": "blue"
      }],
      "mais_fidelidade": [{
        "host": "maisfidelidade-dev.webmotors.com.br",
        "regexp": "/maisfidelidade-dev.(webmotors|cockpit).com.br/",
        "identifier": "mais_fidelidade",
        "environment": "development"
      }, {
        "host": "hkmaisfidelidade.webmotors.com.br",
        "regexp": "/cockpit.com.br\\/moreloyalty/",
        "identifier": "mais_fidelidade",
        "environment": "staging"
      }, {
        "host": "maisfidelidade.webmotors.com.br",
        "regexp": "/((www\\.)|[^(\\.)])cockpit.com.br\\/maisfidelidade/",
        "identifier": "mais_fidelidade",
        "environment": "production"
      }, {
        "host": "azulmaisfidelidade.webmotors.com.br",
        "regexp": "/azl.cockpit.com.br\\/maisfidelidade/",
        "identifier": "mais_fidelidade",
        "environment": "blue"
      }],
      "universidade": [{
        "host": "universidade-dev.webmotors.com.br",
        "regexp": "/universidade-dev.(webmotors|cockpit).com.br/",
        "identifier": "universidade",
        "environment": "development"
      }, {
        "host": "hkuniversidade.webmotors.com.br",
        "regexp": "/cockpit.com.br\\/(universidade|university)/",
        "identifier": "universidade",
        "environment": "staging"
      }, {
        "host": "universidade.webmotors.com.br",
        "regexp": "/((www\\.)|[^(\\.)])cockpit.com.br\\/(universidade|university)/",
        "identifier": "universidade",
        "environment": "production"
      }, {
        "host": "azuluniversidade.webmotors.com.br",
        "regexp": "/azl.cockpit.com.br\\/(universidade|university)/",
        "identifier": "universidade",
        "environment": "blue"
      }]
    }
  },
  "ApiLogin": "/api/login",
  "ApiLoginWebmotors": "https://login.webmotors.com.br/api/login",
  "ApiCockpit": "/api/cockpit",
  "ApiMenu": "/api/cockpit",
  "ApiCockpitLambda": "/api/cockpit",
  "ApiCDN": "/api/central-de-notificacao/v1",
  "ApiSisense": "https://sisense.webmotors.com.br/api",
  "ApiStore": "/api/cockpit/store",
  "ApiMaisFidelidade": "https://cockpit.webmotors.com.br/api/cockpit/maisfidelidade",
  "ApiCRM": "https://crm.webmotors.com.br/v3",
  "ApiEstoque": "https://betaestoque.webmotors.com.br",
  "ApiEstoquePlataforma": "https://betaestoque.webmotors.com.br",
  "UrlAutoguru": "/autoguru",
  "UrlCockpit": "",
  "UrlCockpitOld": "https://cockpit.webmotors.com.br",
  "UrlComprarVeiculos": "/resale",
  "UrlCRM": "/crm",
  "UrlEstoque": "/inventory",
  "UrlEstoquePlataforma": "/inventory/php",
  "UrlGearbox": "/campaigns",
  "UrlCampaigns": "/campaigns",
  "UrlSite": "/site",
  "UrlMaisFidelidade": "/moreloyalty",
  "UrlUniversidade": "/university",
  "UrlStore": "/store"
};